import { ALERTS_COOLDOWN_MS } from './alerts.constants'

const STORAGE_KEY = 'alertsCoordinatorLastShownAt'

export function recordAlertsCoordinatorShownAt(timestamp = Date.now()): void {
  try {
    if (typeof sessionStorage !== 'undefined') {
      sessionStorage.setItem(STORAGE_KEY, timestamp.toString())
    }
  } catch {
    // ignore quota or private mode
  }
}

export function getAlertsCoordinatorCooldownRemainingMs(now = Date.now()): number {
  try {
    if (typeof sessionStorage === 'undefined') {
      return 0
    }

    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) {
      return 0
    }

    const lastShownAt = Number(raw)
    if (Number.isNaN(lastShownAt)) {
      return 0
    }

    const elapsed = now - lastShownAt
    if (elapsed >= ALERTS_COOLDOWN_MS) {
      return 0
    }

    return ALERTS_COOLDOWN_MS - elapsed
  } catch {
    return 0
  }
}
